import styled from 'styled-components';

export const Content = styled.div`
  h1 {
    margin-left: 2rem;
    font-size: 1.5rem;
    color: ${({ theme }) => theme.colors.secondary};
    font-weight: 600;
  }

  .loading {
    display: flex;
    align-items: center;

    img {
      width: 2rem;
      aspect-ratio: 1;
    }

    p {
      margin-left: 0.5rem;
      font-style: italic;
      color: ${({ theme }) => theme.colors.text};
    }
  }

  @media (max-width: 780px) {
    h1 {
      margin-left: 0;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  gap: 0.5rem;
  margin: 1rem 2rem 0 2rem;
  padding: 1rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.text};

  @media (max-width: 780px) {
    flex-direction: column;
  }

  @media (max-width: 310px) {
    margin: 0.5rem 0.5rem;
  }
`;

export const Body = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  h2 {
    font-size: 1.5rem;
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 300;
  }

  p {
    font-size: 1.4rem;
    margin-left: 3rem;
    font-weight: 300;
    color: ${({ theme }) => theme.colors.gray};
  }

  .containerSolicitationData {
    display: grid;
    grid-template-columns: 50% 50%;
    gap: 1rem;

    .container {
      margin-top: 3rem;
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .correspondeceService {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .containerDateLimit {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .containerDate {
      display: flex;
      align-items: center;
      gap: 1rem;
      flex-wrap: wrap;

      .contentDate {
        display: flex;
        gap: 1rem;
        align-items: baseline;
        margin-left: 3rem;

        span {
          display: flex;
          justify-content: center;
          height: 1.3rem;
          width: 3rem;
          padding: 0.2rem 0;
          font-size: 1.2rem;
          color: ${({ theme }) => theme.colors.gray};
          border-bottom: 1px solid ${({ theme }) => theme.colors.text};
        }
      }
    }

    .containerMapAttachment {
      display: flex;
      flex-wrap: wrap;
      gap: 1.5rem;
      width: 100%;
      max-width: 85%;
      margin: 0.5rem 3rem;
      max-height: 4.5rem;
      overflow-y: auto;

      ::-webkit-scrollbar {
        width: 8px;
        background-color: ${({ theme }) => theme.colors.background};
        border-radius: 10px;
      }

      ::-webkit-scrollbar:horizontal {
        height: 5px;
      }

      ::-webkit-scrollbar-track,
      ::-webkit-scrollbar-track-horizontal {
        border-radius: 10px;
      }

      ::-webkit-scrollbar-thumb,
      ::-webkit-scrollbar-thumb:horizontal {
        background-color: ${({ theme }) => theme.colors.tertiary_500};
        border-radius: 10px;
      }
    }

    .containerClient {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .containerData {
      width: 100%;
      display: flex;
      margin-top: 3rem;
      flex-direction: column;
      gap: 1rem;
    }

    .containerNote {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      p {
        width: 70%;
        max-height: 10rem;
        min-height: 1rem;
        font-size: 1.2rem;
        overflow-y: auto;

        ::-webkit-scrollbar {
          width: 8px;
          background-color: ${({ theme }) => theme.colors.background};
          border-radius: 10px;
        }

        ::-webkit-scrollbar:horizontal {
          height: 5px;
        }

        ::-webkit-scrollbar-track,
        ::-webkit-scrollbar-track-horizontal {
          border-radius: 10px;
        }

        ::-webkit-scrollbar-thumb,
        ::-webkit-scrollbar-thumb:horizontal {
          background-color: ${({ theme }) => theme.colors.tertiary_500};
          border-radius: 10px;
        }
      }
    }
  }

  .containerApprover {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .containerMap {
    width: 90%;

    .google-map {
      margin: 0 2rem;
      pointer-events: none !important;
    }

    .containerLocation {
      margin-left: 1.9rem;
      margin-bottom: 1rem;
      width: 85%;
      gap: 1rem;

      h1,
      p {
        margin-left: 0;
      }
    }
  }

  @media (max-width: 780px) {
    gap: 0.5rem;

    p {
      margin-left: 0;
    }

    .containerSolicitationData .containerNote p {
      width: 100%;
    }

    .containerDateLimit .containerDate .contentDate {
      margin-left: 0;
    }

    .containerMap {
      width: 100%;

      .google-map {
        margin: 0;
        pointer-events: none !important;
      }

      .containerLocation {
        margin-left: 0;
      }
    }
  }

  @media (max-width: 470px) {
    .containerSolicitationData {
      grid-template-columns: 100%;
      gap: 0;

      .containerMapAttachment {
        max-width: 100%;
        margin: 0;
        max-height: 8.5rem;
        min-height: 1rem;
      }

      .container {
        margin-top: 0.5rem;
      }

      .containerData {
        margin-top: 0;
      }
    }
  }
`;

export const ContainerProviders = styled.form`
  display: flex;
  margin: 1.5rem;
  gap: 2rem;

  h1 {
    margin: 0;
  }

  @media (max-width: 1030px) {
    gap: 1rem;
  }

  @media (max-width: 1476px) {
    flex-direction: column;
  }

  @media (max-width: 310px) {
    margin: 0.5rem;
  }
`;

export const Providers = styled.div`
  width: 100%;

  .content-selected-user {
    min-height: 38rem;
    width: 100%;
    display: flex;

    .content-cards-users {
      width: 100%;
      height: auto;
      .content-card{
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 1rem;
        width: 100%;
      }
    }

    .content-user {
      margin-bottom: 20px;
      max-width: 100%;
      height: 35rem;
      padding: 1rem;
      overflow-y: auto;
      display: grid;
      align-content: start;
      grid-template-columns: auto auto auto;

      @media (max-width: 1235px) {
        grid-template-columns: auto auto;
        @media (max-width: 1235px) {
          grid-template-columns: auto;
        }
      }

      ::-webkit-scrollbar {
        width: 8px;
        background-color: ${({ theme }) => theme.colors.background};
        border-radius: 10px;
      }

      ::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.colors.tertiary_500};
        border-radius: 10px;
      }
    }
  }

  .footerContent {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .generateContainer {
      display: flex;
      flex-direction: column;
      align-items: center;

      h1 {
        color: ${({ theme }) => theme.colors.tertiary_500};
        font-weight: 500;
        white-space: nowrap;
      }

      span {
        font-weight: 300;
      }
    }
  }

  @media (max-width: 630px) {
    .content-selected-user {
      flex-direction: column;
      align-items: center;
    }
  }

  @media (max-width: 560px) {
    .footerContent {
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
    }
  }
`;

export const HeaderProvider = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  .providerSearch {
    margin-right: 25px;
    width: 32%;

    .MuiInput-input {
      color: ${({ theme }) => theme.colors.text};
      font-size: 1.1rem;
    }
  }

  @media (max-width: 830px) {
    .providerSearch {
      margin-right: 0;
      width: auto;
    }
  }
`;
